export function extractVerifyToken(text) {
  try {
    const url = new URL(text);
    const match = url.pathname.match(/\/semak\/([^/?#]+)/);
    if (match) return match[1];
  } catch {
    // not a URL, fall through
  }
  return text.trim();
}
